import { configureStore } from '@reduxjs/toolkit';

// import reduxLogger from 'redux-logger';

import picksReducer from './features/picks/picksSlice';
import teamsReducer from './features/teams/teamsSlice';
import matchupsReducer from './features/matchups/matchupsSlice';

export default configureStore({
  reducer: {
    picks: picksReducer,
    teams: teamsReducer,
    matchups: matchupsReducer,
  },
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(reduxLogger),
});
